export default __webpack_public_path__ + "static/6827-f8f400eb276bf398f90bc46021aea73f.jpg";